import { Injectable } from '@angular/core';
import { ChangeInvestmentInstructionSubmissionTypeEnum } from '../../../../models/enum/shared/change-investment-instruction-submission-type.enum';
import { AccountTypeIdEnum } from '../../../../models/transactions/enum/account-type-id.enum';

@Injectable({
  providedIn: 'root'
})
export class InvestmentInstructionSubmissionFormService {
  public selectedSubmissionType: ChangeInvestmentInstructionSubmissionTypeEnum | null = null;
  public setSelectedSubmissionType = (type: ChangeInvestmentInstructionSubmissionTypeEnum | null) => {
    this.selectedSubmissionType = type;
  };

  public selectedAccountTypeId: AccountTypeIdEnum | undefined = undefined;
  public setSelectedAccountTypeId = (type: AccountTypeIdEnum | undefined) => {
    this.selectedAccountTypeId = type;
  };
}
